
  var _styles = {
  "container": {
    "position": "fixed",
    "width": "10rem"
  },
  "background": {
    "backgroundColor": "rgb(255,255,255)",
    "overflow": "hidden",
    "borderBottomLeftRadius": "0.32rem",
    "borderBottomRightRadius": "0.32rem",
    "zIndex": 1000
  },
  "tag-background": {
    "backgroundColor": "rgb(255,255,255)",
    "overflow": "hidden",
    "borderBottomLeftRadius": "0.32rem",
    "borderBottomRightRadius": "0.32rem",
    "padding": "0.32rem",
    "zIndex": 1000
  },
  "tab-items-wrapper": {
    "display": "flex",
    "flexDirection": "row",
    "flexWrap": "wrap",
    "paddingLeft": "0.4rem"
  },
  "tabTitle": {
    "display": "flex",
    "flexDirection": "row",
    "justifyContent": "space-between",
    "marginBottom": "0.48rem",
    "paddingLeft": "0.16rem",
    "paddingRight": "0.16rem"
  },
  "tab-items": {
    "borderWidth": 0,
    "borderStyle": "solid",
    "borderColor": "rgb(255,255,255)",
    "borderRadius": "0.16rem",
    "fontWeight": "500",
    "fontFamily": "PingFangSC-Regular",
    "fontSize": "0.37333rem",
    "color": "rgb(102,102,102)",
    "height": "0.93333rem",
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "justifyContent": "flex-start",
    "marginBottom": "0.16rem",
    "marginRight": "0.16rem"
  },
  "tab-items-active": {
    "borderWidth": 0,
    "borderStyle": "solid",
    "borderColor": "rgb(255,255,255)",
    "borderRadius": "0.16rem",
    "fontWeight": "500",
    "fontFamily": "PingFangSC-Regular",
    "fontSize": "0.37333rem",
    "color": "rgb(255,75,16)",
    "height": "0.93333rem",
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "justifyContent": "flex-start",
    "marginBottom": "0.16rem",
    "marginRight": "0.16rem"
  },
  "tabTagTitle": {
    "display": "flex",
    "flexDirection": "row",
    "justifyContent": "flex-end"
  },
  "tag-items-wrapper": {
    "display": "flex",
    "flexDirection": "row",
    "flexWrap": "wrap"
  },
  "tag-tab-items": {
    "marginBottom": "0.16rem",
    "marginRight": "0.16rem",
    "padding": "0.24rem"
  },
  "horizontaldirecotryMdoal": {
    "position": "fixed",
    "left": 0,
    "top": 0,
    "width": "100vw",
    "height": "100vh",
    "opacity": 0.5,
    "background": "#000",
    "zIndex": 999
  }
};



  module.exports = _styles;
  